import React, { useEffect, useState, useRef } from 'react';
import Modal from "../common/modal";
import {
  statInitialData, handleStatPageScroll, statSendData, handleStatCancelExitClick
} from '../common/statistics';
import Header from "./header";
import Footer from "./footer";
import Hero from "./hero";
import Calc from "./calc";
import Reasons from "./reasons";
import Steps from "./steps";
import About from "./about";
import Questions from "./questions";

const ConceptBau = () => {
  const [ finishedExercise, setFinishedExercise ] = useState(false);

  const [ showTopStripe, setShowTopStripe ] = useState(false);

  const [ openModal, setOpenModal ] = useState(false);

  const layoutRef = useRef(null);

  useEffect(() => {
    statInitialData();
    setTimeout(() => {
      setShowTopStripe(true);
    }, 15000);
  }, []);

  const handleSetContentRef = (el) => {
    if (el) {
      layoutRef.current = el;
      layoutRef.current.onscroll = () => {
        if (layoutRef.current) {
          handleStatPageScroll(layoutRef.current);
        }
      };
    }
  };

  const handleShowModalFinish = () => {
    setOpenModal(true);
  };

  const closeModalFinish = () => {
    handleStatCancelExitClick();
    setOpenModal(false);
  };

  const finishMailApp = () => {
    statSendData();
    setFinishedExercise(true);
  };

  return (
    <>
      {
        finishedExercise ? (
          <></>
        ) : (
          <div className="wrapper">
            {
              !!showTopStripe &&
              <div className="top-stripe">
                Please click
                <button className="top-stripe_button" onClick={ handleShowModalFinish }>here</button>
                to return to the survey
              </div>
            }
            <div className="layout">

              <div className="layout_header">
                <Header />
              </div>

              <div className="layout_main scroll-container" ref={ handleSetContentRef }>
                <div className="content">
                  <Hero />
                  <div className="content_spacer" />
                  <Calc />
                  <div className="content_spacer -lg" />
                  <Reasons />
                  <div className="content_spacer -md-tablet" />
                  <Steps />
                  <div className="content_spacer -lg" />
                  <About />
                  <div className="content_spacer -lg" />
                  <Questions />
                </div>
                <Footer />
              </div>
            </div>
            {
              openModal &&
              <Modal
                modal
                handleClose={ closeModalFinish }
                title="Do you really want to leave the app and return to the survey?"
                classNameDialog="-sm -finish-app"
              >
                <div className="modal_buttons">
                  <button className="button" onClick={ finishMailApp }>Yes</button>
                  <button className="button -bordered" onClick={ closeModalFinish }>No</button>
                </div>
              </Modal>
            }
          </div>
        )
      }
    </>
  );
};

export default ConceptBau;
